import React from 'react';
import moment from 'moment';

import {Grid, List, ListItem, ListItemText, Tooltip} from '@mui/material';
import {red} from '@mui/material/colors';
import {useStyles} from '../styles';
import {useStyles as useItemStyles} from '../stylesItem';

const ROW_HEIGHT = 25
const ROOM_PART_MIN_WIDTH = 100

const toMinutes = time => {
  const parsed = moment(time, 'HH:mm')
  return parsed.hours() * 60 + parsed.minutes()
}

const WeekendBlock = ({block, gridStartMinutes, timeSlot}) => {
  const itemClasses = useItemStyles();
  const top = (toMinutes(block.TimeBegin) - gridStartMinutes) / timeSlot * ROW_HEIGHT
  const height = (toMinutes(block.TimeEnd) - toMinutes(block.TimeBegin)) / timeSlot * ROW_HEIGHT
  const timeString = `${block.TimeBegin} - ${block.TimeEnd}`

  return (
    <Tooltip
      placement="top"
      title={(
        <>
          <div>{block.Department} ({timeString})</div>
          {block.Events.map(event => (
            <div key={event.id}>{event.TimeBegin} - {event.TimeEnd} {event.Title}</div>
          ))}
        </>
      )}
    >
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top,
          height,
          boxSizing: 'border-box',
          overflow: 'hidden',
          // alternating row colors aligned to the grid rows, like the weekday bookings (fullOdd / full)
          backgroundColor: red['500'],
          backgroundImage: `linear-gradient(to bottom, ${red['400']} ${ROW_HEIGHT}px, ${red['500']} ${ROW_HEIGHT}px)`,
          backgroundSize: `100% ${2 * ROW_HEIGHT}px`,
          backgroundPosition: `0 ${-top}px`,
          backgroundOrigin: 'border-box',
          border: `1px solid ${red['700']}`,
          textAlign: 'center',
          // same text size as the department title and note of the weekday bookings
          fontSize: '12px',
          lineHeight: 1.43,
          paddingTop: '4px',
        }}
      >
        <span className={itemClasses.title}>{block.Department}</span>
        {block.Events.map(event => (
          <div key={event.id}>
            <span className={itemClasses.note}>{event.TimeBegin} {event.Title}</span>
          </div>
        ))}
      </div>
    </Tooltip>
  )
}

/**
 * Saturday / Sunday of the public view: the bookings belong to the whole room, so a block spans all room parts.
 */
const WeekendDay = ({day, times, timeSlot, roomPartCount}) => {
  const classes = useStyles();
  const itemClasses = useItemStyles();

  const gridStartMinutes = times.length ? toMinutes(times[0].format('HH:mm')) : 0

  return (
    <Grid item className={classes.grid} style={{minWidth: Math.max(roomPartCount, 1) * ROOM_PART_MIN_WIDTH}}>
      <List disablePadding>
        <ListItem className={classes.listItem} style={{height: '50px'}}>
          <ListItemText primary={day.Title} />
        </ListItem>
      </List>

      <div style={{position: 'relative'}}>
        {times.map((time, index) => (
          <div
            key={time.format('HH:mm')}
            className={`${itemClasses.listItemSub} ${index % 2 === 0 ? itemClasses.availableOdd : itemClasses.available}`}
            style={{cursor: 'default'}}
          />
        ))}
        {timeSlot && day.WeekendBlocks.map(block => (
          <WeekendBlock
            key={block.id}
            block={block}
            gridStartMinutes={gridStartMinutes}
            timeSlot={timeSlot}
          />
        ))}
      </div>
    </Grid>
  );
}

export default WeekendDay;
